export default num => {
  if (isNaN(num)) return `${num}`

  if (num < 999) {
    return `${num}`
  }

  if (num < 1000000) {
    return `${Math.round((num / 1000) * 10) / 10}K`
  }

  if (num < 10000000) {
    return `${Math.round((num / 1000000) * 10) / 10}M`
  }

  if (num < 1000000000) {
    return `${Math.round(num / 1000000)}M`
  }

  if (num < 1000000000000) {
    return `${Math.round(num / 1000000000)}B`
  }

  return '1T+'
}
